<template>
  <div>
    <app-form
      v-bind:parentObject="{
        data: this.formData,
        pageTitle: this.pageTitle,
        pageTitleValue: this.pageTitleValue,
        errMsg: this.errMsg,
        isEdit: this.editMode,
      }"
      v-on:input="formData = $event"
      v-on:save="saveHandler"
      v-on:error="errorHandler"
    />
    <div v-if="isErr">
      <app-error
        v-bind:parentError="{
          data: this.errMsg,
          isErr: this.isErr,
        }"
        v-on:closeError="isErr = $event"
      />
    </div>
  </div>
</template>

<script>

import RankMapSetForm from "../../../components/performance/rankmapset/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
  components: {
    "app-form": RankMapSetForm,
    "app-error": ErrorDialog,
  },

  data() {
    return {
      pageTitle: this.$t('Setuprankmapset.createnewrankmapset'),
      pageTitleValue: "",
      formData: {
        rankmapset: null,
        description: null,
        disable: false,
        weightedavg: false,
        remark: null,
        stamp: 0,
        userid: this.$store.getters.userId,
      },
      errMsg: "",
      isErr: false,
      editMode: false,
    };
  },

  methods: {

    errorHandler($event) {
      this.isErr = $event.isErr;
      this.errMsg = $event.errMsg;
    },

    saveHandler() {
      const vm = this;

      if (!this.CheckPermission(this.$route.meta.funcname, "canadd")) {
        return false;
      }

      this.$store.dispatch('post', {url: "/rankmapset/create", payload: this.formData})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            if (Array.isArray(res.data.error)) {
                vm.errMsg = res.data.error.map((e, index) => `${index + 1}. ${e.msg}`).join('\n');
            } else {
                vm.errMsg = res.data.error;
            }
          }else {
            this.$router.push({ name: "rankmapsetlist" });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
           console.log("err", err);
        });
    },
  },
};
</script>